import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState } from "@faire/web/ui/hooks/useState";
import { useCallback } from "react";
export var useNodesConditionalVisibilityState = function useNodesConditionalVisibilityState() {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    nodesConditionalVisibility = _useState2[0],
    setNodesConditionalVisibility = _useState2[1];
  var updateNodeVisibility = useCallback(function (node, isVisible) {
    setNodesConditionalVisibility(function (values) {
      return _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, node.id, isVisible));
    });
  }, []);
  return {
    nodesConditionalVisibility: nodesConditionalVisibility,
    updateNodeVisibility: updateNodeVisibility
  };
};